import { Component, input, OnInit, output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DropdownObject } from '@inmoment/the-kitchen';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { SUPPORTED_LANGUAGE_CODES, SUPPORTED_LANGUAGE_MAP } from 'app/transloco-root.module';

@EnableClassTelemetry()
@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss'],
  standalone: false,
})
export class ChangeLanguageComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  readonly langCode = input<string>();

  readonly close = output<string | null>();

  form: UntypedFormGroup;

  ds: DropdownObject[] = [];

  constructor(formBuilder: UntypedFormBuilder) {
    this.form = formBuilder.group({
      code: ['', Validators.required],
    });

    SUPPORTED_LANGUAGE_CODES.map(
      (c) =>
        ({
          id: c,
          title: `${SUPPORTED_LANGUAGE_MAP[c]} (${c.toUpperCase()})`,
        }) as DropdownObject
    )
      .sort((a, b) => a.title.localeCompare(b.title))
      .forEach((o) => this.ds.push(o));
  }

  ngOnInit(): void {
    this.form.patchValue({
      code: this.langCode(),
    });
  }

  onSet(): void {
    this.close.emit(this.form.controls.code.value);
  }

  onCancel(): void {
    this.close.emit(null);
  }
}
